import { apiClient, getCookie } from './api';
import $ from 'jquery';
import { showLoginModal } from '../login';

// Flag reasons mapping
export const FLAG_REASONS = {
    'INAPPROPRIATE': 'Inappropriate Content',
    'SPAM': 'Spam',
    'COPYRIGHT': 'Copyright Violation',
    'OTHER': 'Other'
};

/**
 * Flag a bitmap
 * @param {number} bitmapId - The ID of the bitmap to flag
 * @param {string} reason - The reason for flagging (INAPPROPRIATE, SPAM, COPYRIGHT, OTHER)
 * @param {string} description - Optional description
 * @param {function} onSuccess - Success callback
 * @param {function} onError - Error callback
 */
export async function flagBitmap(bitmapId, reason, description = '', onSuccess, onError) {
    const endpoint = `/api/bitmaps/flag/${bitmapId}/`;
    const data = {
        reason: reason,
        description: description
    };

    await apiClient(endpoint, {
        method: 'POST',
        body: JSON.stringify(data),
        notJSON: false
    }, onSuccess, onError);
}

/**
 * Unflag a bitmap
 * @param {number} bitmapId - The ID of the bitmap to unflag
 * @param {function} onSuccess - Success callback
 * @param {function} onError - Error callback
 */
export async function unflagBitmap(bitmapId, onSuccess, onError) {
    const endpoint = `/api/bitmaps/unflag/${bitmapId}/`;
    
    await apiClient(endpoint, {
        method: 'DELETE'
    }, onSuccess, onError);
}

/**
 * Update flag UI state
 * @param {number} bitmapId - The ID of the bitmap
 * @param {boolean} isFlagged - Whether the bitmap is flagged by the current user
 * @param {number} flagCount - Total number of flags on the bitmap
 */
export function updateFlagUI(bitmapId, isFlagged, flagCount) {
    const $flagIcon = $(`#flag_bitmap_${bitmapId}`);
    const $flagCount = $(`#flag_count_${bitmapId}`);
    
    if (isFlagged) {
        $flagIcon.addClass('selected');
        $flagIcon.attr('title', 'Remove flag');
    } else {
        $flagIcon.removeClass('selected');
        $flagIcon.attr('title', 'Flag this bitmap');
    }
    
    if (flagCount > 0) {
        $flagCount.text(flagCount).removeClass('hidden');
    } else {
        $flagCount.addClass('hidden');
    }
}

/**
 * Show flag modal
 * @param {number} bitmapId - The ID of the bitmap to flag
 */
export function showFlagModal(bitmapId) {
    // Create modal HTML if it doesn't exist
    if ($('#flag-modal').length === 0) {
        const modalHtml = `
            <div id="flag-modal" class="modal" style="display: none;">
                <div class="modal-content">
                    <span class="close">&times;</span>
                    <h2>Flag Bitmap</h2>
                    <form id="flag-form">
                        <input type="hidden" id="flag-bitmap-id" value="">
                        <div class="form-group">
                            <label for="flag-reason">Reason:</label>
                            <select id="flag-reason" name="reason" required>
                                <option value="">Select a reason</option>
                                ${Object.entries(FLAG_REASONS).map(([value, label]) => 
                                    `<option value="${value}">${label}</option>`
                                ).join('')}
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="flag-description">Additional details (optional):</label>
                            <textarea id="flag-description" name="description" rows="4"></textarea>
                        </div>
                        <div class="form-actions">
                            <button type="submit" class="btn btn-primary">Submit Flag</button>
                            <button type="button" class="btn btn-secondary cancel">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        `;
        $('body').append(modalHtml);
        
        // Bind modal events
        $('#flag-modal .close, #flag-modal .cancel').on('click', function() {
            $('#flag-modal').hide();
        });
        
        $('#flag-form').on('submit', function(e) {
            e.preventDefault();
            submitFlag();
        });
    }
    
    // Set bitmap ID and show modal
    $('#flag-bitmap-id').val(bitmapId);
    $('#flag-reason').val('');
    $('#flag-description').val('');
    $('#flag-modal').show();
}

/**
 * Submit flag form
 */
function submitFlag() {
    const bitmapId = $('#flag-bitmap-id').val();
    const reason = $('#flag-reason').val();
    const description = $('#flag-description').val();
    
    if (!reason) {
        alert('Please select a reason for flagging.');
        return;
    }
    
    flagBitmap(bitmapId, reason, description,
        (response) => {
            $('#flag-modal').hide();
            updateFlagUI(bitmapId, true, response.flag_count || 1);
            alert('Bitmap has been flagged. Thank you for your report.');
        },
        (error) => {
            let errorMessage = 'Failed to flag bitmap.';
            if (error.detail) {
                errorMessage = error.detail;
            } else if (error.non_field_errors) {
                errorMessage = error.non_field_errors.join(' ');
            }
            alert(errorMessage);
        }
    );
}

/**
 * Initialize flag handlers for bitmap elements
 */
export function initializeFlagHandlers() {
    // Delegate click handlers for dynamically loaded content
    $(document).on('click', '.icon_flag, [data-action="flag"]', function(e) {
        e.preventDefault();
        
        // Check if user is authenticated
        const accessToken = getCookie('access_token');
        if (!accessToken) {
            showLoginModal();
            return;
        }
        
        const bitmapId = $(this).data('bitmap-id') || $(this).attr('id').replace('flag_bitmap_', '');
        const isFlagged = $(this).hasClass('selected');
        
        if (isFlagged) {
            // Unflag
            if (confirm('Remove your flag from this bitmap?')) {
                unflagBitmap(bitmapId,
                    (response) => {
                        updateFlagUI(bitmapId, false, response.flag_count || 0);
                        alert('Flag removed successfully.');
                    },
                    (error) => {
                        if (error.detail && error.detail.includes('Authentication')) {
                            showLoginModal();
                        } else {
                            alert('Failed to remove flag: ' + (error.detail || 'Unknown error'));
                        }
                    }
                );
            }
        } else {
            // Show flag modal
            showFlagModal(bitmapId);
        }
    });
}